// extracted by mini-css-extract-plugin
export default {"page":"witch-skill_page__Ud-Yk"};